<!--
  ~ Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
  ~ This software is the proprietary information of Irian Software Development SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div *ngIf="displayButton" style="display: flex">
  <button pButton type="button" icon="ui-icon-notifications" class="flat notification-ui-button-component"
           [label]="count | async" (click)="handleClick()" data-testid="click-btn"></button>


</div>
